import App from './App';
import { renderNav } from './core/strategies';
import { NavType } from './constants';
new App({
  navType: NavType.VERTICAL
}).start(renderNav);